```vue
<template>
  <div class="subscribe-area bg-50 position-relative">
    <div class="container mw-1356">
      <div class="bg-golden ptb-60 position-relative z-1 overflow-hidden">
        <div class="row align-items-center">
          <div
            class="col-lg-6"
            data-aos="fade-up"
            data-aos-duration="1000"
            data-aos-delay="100"
          >
            <div class="subscribe-img">
              <img :src="subscribeImage" alt="subscribe" />
            </div>
          </div>

          <div
            class="col-lg-6"
            data-aos="fade-up"
            data-aos-duration="1000"
            data-aos-delay="200"
          >
            <div class="subscribe-content">
              <h3>{{ heading }}</h3>
              <form @submit.prevent="handleSubmit">
                <label class="label">البريد الإلكتروني</label>
                <div class="d-sm-flex">
                  <input
                    v-model="email"
                    type="email"
                    class="form-control"
                    :placeholder="placeholder"
                    required
                  />
                  <button type="submit" class="btn active ms-1 mt-2 mt-sm-0">
                    <span class="border-style">{{ buttonText }}</span>
                  </button>
                </div>
              </form>
              <p>
                بالضغط على زر الاشتراك فإنك توافق على
                <RouterLink to="/terms-conditions" class="text-decoration-none">
                  الشروط والأحكام.
                </RouterLink>
              </p>
            </div>
          </div>
        </div>

        <img :src="shape3" class="shape shape-3" alt="shape" />
        <img :src="shape4" class="shape shape-4" alt="shape" />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref } from "vue";

export default defineComponent({
  name: "SubscribeContent",
  props: {
    heading: {
      type: String,
      default:
        "اشترك ليصلك كل جديد حول العروض الحصرية والباقات الجديدة وأحدث التحديثات الخاصة بخدماتنا.",
    },
    placeholder: {
      type: String,
      default: "أدخل بريدك الإلكتروني",
    },
    buttonText: {
      type: String,
      default: "اشتراك",
    },
    subscribeImage: {
      type: String,
      default: require("@/assets/images/subscribe.png"),
    },
    shape3: {
      type: String,
      default: require("@/assets/images/shape-3.png"),
    },
    shape4: {
      type: String,
      default: require("@/assets/images/shape-4.png"),
    },
  },
  setup() {
    const email = ref("");

    const handleSubmit = () => {
      if (email.value) {
        console.log("Email submitted:", email.value);
        email.value = "";
      }
    };

    return {
      email,
      handleSubmit,
    };
  },
});
</script>
```
